module.exports = __webpack_public_path__ + "fonts/429ef8cbfc77367aa9468b16a0d8de3c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/img/vehicle.svg
// module id = 285
// module chunks = 0